import Reflux from "reflux";

const ImageActions = Reflux.createActions([
  "endTransform",
  "enterCropMode",
  "exitAndSaveCropMode",
  "exitCropMode",
  "exitFinished",
  "startTransform",
  "transform",
  "updateCrop",
]);

export default ImageActions;
